import React from 'react';
import './css/Login.css';
import ReactHtmlParser from 'react-html-parser';
import CustomizedSnackbars from './Message';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import logo from './logo.png';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'© '}
      {new Date().getFullYear()}
      {' '}
      {'allstardirectories.com. All rights reserved.'}
      {' '}
    </Typography>
  );
}
class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      asd_username: '',
      asd_password: '',
      checked: false,
      error: {
        error_message: ''
      },
      success: {
        success_message: ''
      },
      isAuthenticate: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCheck = this.handleCheck.bind(this);

  }

  componentDidMount() {
    window.history.pushState(null, null, window.location.pathname);
    let remember = localStorage.getItem('remember');
    if (remember == "true") {
      let username = window.atob(localStorage.getItem('username'));
      let password = window.atob(localStorage.getItem('password'));
      this.setState({ asd_username: username, asd_password: password, checked: remember });
    }
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
  }
  handleCheck(event) {
    this.setState({ checked: event.target.checked });
  };

  handleSubmit(event) {
    event.preventDefault();
    let asd_username = this.state.asd_username;
    let asd_password = this.state.asd_password;
    let asd_remember = this.state.checked;

    if ("" === asd_username) {
      this.setState({
        error: {
          error_message: 'Please Enter Username'
        }
      });
      return false;
    } else if ("" === asd_password) {
      this.setState({
        error: {
          error_message: 'Please Enter Password'
        }
      });
      return false;
    } else {
      this.setState({
        error: {
          error_message: ''
        }
      });
    }
    const loginData = { username: asd_username, password: asd_password, remember: asd_remember };

    const requestOptions = {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify({ asd_username, asd_password, asd_remember }),
    };

    fetch(`./wp-json/asd/oauth/login`, requestOptions)
      .then(response => response.json())
      .then(data => {
        if (false === data.success) {
          this.setState({
            error: {
              error_message: data.message
            }
          });
        } else {
          this.setState({
            success: {
              success_message: data.message
            }
          });

          this.setState({
            error: {
              error_message: ''
            }
          });
          if (data.token != null) {
            localStorage.setItem('token', data.token);
            localStorage.setItem('userId', data.userId);
            localStorage.setItem('userRole', data.userRole);
            localStorage.setItem('inpersonate', false);
            localStorage.setItem('remember', asd_remember);
            if (asd_remember) {
              localStorage.setItem('username', window.btoa(asd_username));
              localStorage.setItem('password', window.btoa(asd_password));
            } else {
              localStorage.removeItem('username');
              localStorage.removeItem('password');
            }
            this.setState({ asd_username: '', asd_password: '' });
            window.location.href = './';
          }
        }
      });

  }

  render() {
    const error = this.state.error.error_message;
    const success = this.state.success.success_message;
    const useStyles = makeStyles(theme => ({
      '@global': {
        body: {
          backgroundColor: theme.palette.common.white,
        },
      },
      paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
      avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
      },
      form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
      },
      button: {
        margin: theme.spacing(13, 0, 2),
        background: 'orange'
      },
    }));
    const classes = useStyles;
    return (
      <div className="App login-wrap">
        <header className="App-header">
          <Container component="main" className="p-8" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
              <div className="loginform">
                <img src={logo} alt="logo" width="200px" height="100px" />
                {error ?
                  <CustomizedSnackbars
                    type="error"
                    message={ReactHtmlParser(this.state.error.error_message)}
                  /> : ''}

                {success ?
                  <CustomizedSnackbars
                    type="success"
                    message={ReactHtmlParser(this.state.success.success_message)}
                  /> : ''}
                <form className={classes.form} noValidate onSubmit={this.handleSubmit}>
                  <TextField

                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    required
                    id="asd_username"
                    label="Required"
                    className="login_text"
                    label="Username"
                    name="asd_username"
                    value={this.state.asd_username} onChange={this.handleChange.bind(this)}
                  //autoFocus
                  />
                  <TextField
                    variant="outlined"
                    margin="normal"
                    id="asd_password"
                    label="Required"
                    className="password_text"
                    fullWidth
                    label="Password"
                    type="password"
                    name="asd_password"
                    inputProps={{
                      autocomplete: 'new-password',
                      form: {
                        autocomplete: 'off',
                      },
                    }}
                    value={this.state.asd_password} onChange={this.handleChange.bind(this)}
                  //autoFocus
                  />
                  <label htmlFor="rememberme" className="rememberme float-left">
                    <Checkbox
                      checked={this.state.checked}
                      onChange={this.handleCheck.bind(this)}
                      value="primary"
                      inputProps={{ 'aria-label': 'primary checkbox' }}
                      name="remember"
                    />
                    Remember Me
                  </label>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className="login-btn"
                  >
                    Sign In
                  </Button>

                  <Grid container>
                    <Grid item xs>
                      <Link href="/lostpassword" variant="body2">
                        Forgot password?
                      </Link>
                    </Grid>

                  </Grid>
                </form>
              </div>
            </div>
          </Container>

        </header>
        <footer><Copyright /></footer>
      </div>

    );
  }
}


export default LoginForm;
